import React from "react";
import { useTranslation } from "react-i18next";
import { MuiRhfSelectField } from "../../components/forms/MuiRhfSelectField";
import { GUI_LOCALES } from "./i18n";

export function MuiRhfLanguagesField(props: {
  name: string,
  disabled?: boolean
}) {
  const {t} = useTranslation();

  return (
    <MuiRhfSelectField
      name={props.name}
      variant={'standard'}
      fullWidth={true}
      label={t('Locales.title')}
      list={GUI_LOCALES}
      getListLabel={(language) => t('Locales.' + language)}
      getListKey={(language) => language}
      disabled={props.disabled}
    />
  )
}
